<template>
    <div class="home d-flex" v-resize="onResize">
        <v-dialog
            v-model="profileDialog.isOpen"
            width="1300"
            :persistent="true"
        >
            <v-card>
                <v-app-bar flat style="background: rgb(26, 57, 88)">
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        {{ profileDialog.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        color="white"
                        @click="profileDialog.isOpen = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-card-text>
                    <v-row class="mb-4">
                        <v-col cols="2" class="pt-4 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                New Name
                            </label>
                        </v-col>
                        <v-col cols="6" class="pt-4 pb-0">
                            <v-text-field
                                v-model="profileNameInput"
                                label=""
                                :rules="inputRules"
                                hide-details
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row
                        v-for="(data, index) in profileFilter"
                        :key="index"
                        class="align-center mt-0"
                    >
                        <v-col cols="2">
                            <v-select
                                v-model="data['server_id']"
                                :items="serverData"
                                item-text="server_name"
                                item-value="id"
                                dense
                                outlined
                                hide-details
                                label="Server"
                            />
                        </v-col>

                        <v-col cols="2">
                            <v-select
                                v-model="data['group_mode']"
                                :items="modeOptions"
                                dense
                                outlined
                                hide-details
                                label="Mode"
                                @change="() => onModeChange(data)"
                            />
                        </v-col>

                        <v-col
                            cols="5"
                            v-if="data['group_mode'] === 'regex'"
                            class="d-flex align-center"
                        >
                            <span class="pr-2">regex[</span>
                            <v-text-field
                                v-model="data['group']"
                                dense
                                outlined
                                placeholder="Enter regex"
                                hide-details="auto"
                                class="flex-grow-1 show-details"
                                :rules="regexRule"
                            />
                            <span class="pl-2">]</span>
                        </v-col>

                        <v-col cols="5" v-else>
                            <v-autocomplete
                                v-model="data['group']"
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                                dense
                                outlined
                                hide-details
                                item-text="name"
                                item-value="name"
                                placeholder="Select groups"
                                :items="
                                    groupOption.filter(
                                        (g) => g.server_id === data['server_id']
                                    )
                                "
                            />
                        </v-col>

                        <v-col cols="3" class="d-flex align-center">
                            <v-text-field
                                v-model="data['login']"
                                label="Login"
                                dense
                                outlined
                                hide-details="auto"
                                class="flex-grow-1 show-details"
                                append-icon="mdi-close"
                                @click:append="data['login'] = ''"
                                :rules="loginRule"
                            />
                            <v-btn
                                icon
                                small
                                color="error"
                                class="ml-2"
                                @click="removeProfileFilter(index)"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="d-flex justify-center">
                            <v-btn
                                outlined
                                color="primary"
                                @click="addNewProfileFilter"
                            >
                                <v-icon left small>mdi-plus</v-icon>
                                Add Filter
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="red"
                        @click="profileDialog.isOpen = false"
                        :loading="dialogLoading"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        v-if="profileDialog.mode === 'update'"
                        text
                        color="orange"
                        @click="updateProfile()"
                        :loading="dialogLoading"
                    >
                        Update
                    </v-btn>
                    <v-btn
                        v-else
                        text
                        color="primary"
                        @click="saveProfile()"
                        :loading="dialogLoading"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card class="d-flex flex-grow-1">
            <v-container fluid class="d-flex flex-grow-1">
                <v-row dense class="d-flex flex-grow-1" style="width: 100%">
                    <v-col lg="8" md="8" xs="12" cols="12">
                        <v-card
                            class="d-flex flex-column"
                            style="height: 100%"
                            outlined
                        >
                            <v-card-title
                                style="border-bottom: 1px solid #404040"
                                class="pt-1"
                            >
                                <div
                                    class="text-left"
                                    style="
                                        margin-left: 0;
                                        width: 50%;
                                        font-size: 13px;
                                        font-weight: normal;
                                    "
                                >
                                    MONITOR
                                </div>
                                <div
                                    class="text-right"
                                    style="margin-right: 0; width: 50%"
                                >
                                    <v-icon
                                        color="green"
                                        dark
                                        dense
                                        @click="startDownload"
                                        >mdi-microsoft-excel</v-icon
                                    ><download-excel
                                        id="csvExport"
                                        :fetch="fetchData"
                                        :fields="computedCSVFields"
                                        type="csv"
                                        style="display: none"
                                        :name="downloadExcelName"
                                        :escapeCsv="false"
                                    >
                                    </download-excel>
                                </div>
                            </v-card-title>

                            <v-row
                                class="flex-shrink-0 flex-grow-0"
                                align="center"
                                style="margin: 0"
                            >
                                <v-col
                                    cols="4"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="'Unrealized'"
                                        :value="mainBookTitle.unrealized"
                                        :description="
                                            mainBookTitleDesc.unrealized
                                        "
                                    />
                                </v-col>
                                <v-col
                                    cols="4"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="'Realized'"
                                        :value="mainBookTitle.realized"
                                        :description="
                                            mainBookTitleDesc.realized
                                        "
                                    />
                                </v-col>
                                <v-col
                                    cols="4"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="'Daily Net'"
                                        :value="mainBookTitle.dailyNet"
                                        :description="
                                            mainBookTitleDesc.dailyNet
                                        "
                                    />
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <v-data-table
                                dense
                                :mobile-breakpoint="0"
                                :headers="mainHeader"
                                :items="computedPKData"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :header-props="{ sortIcon: null }"
                                :custom-filter="filterTable"
                                :customSort="customSort"
                                item-key="symbol"
                                @click:row="rowClicked"
                                class="elevation-0 flex-grow-1"
                                :items-per-page="30"
                                :footer-props="{
                                    itemsPerPageOptions: [10, 20, 30],
                                    showFirstLastPage: false,
                                    'items-per-page-text': '',
                                }"
                                id="home-table"
                                :height="tableHeight"
                                fixed-header
                                v-sortable-table="{
                                    onEnd: sortPKHeadersAndUpdateTheKey,
                                }"
                                :key="anIncreasingNumberForMain"
                            >
                                <template v-slot:header.symbol="{ header }">
                                    {{ header.text }}
                                    <v-menu
                                        offset-y
                                        :close-on-content-click="false"
                                        top
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.prevent="
                                                    onSearch('symbolSearch')
                                                "
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>
                                        <div
                                            style="
                                                background-color: #1e1e1e;
                                                width: 280px;
                                            "
                                        >
                                            <v-text-field
                                                v-model="search"
                                                class="px-4"
                                                type="text"
                                                ref="symbolSearch"
                                                label="Enter the search term"
                                                style="width: 100%"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="search = ''"
                                                small
                                                text
                                                color="primary"
                                                class="ml-2 mb-2"
                                                style="padding: 6px"
                                            >
                                                Clear
                                            </v-btn>
                                        </div>
                                    </v-menu>
                                </template>
                                <template v-slot:header.net="{ header }">
                                    <v-tooltip top open-delay="500">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <span v-bind="attrs" v-on="on">{{
                                                header.text
                                            }}</span>
                                        </template>
                                        <span
                                            >Net Volume = Long + Short (Sort by
                                            absolute value)</span
                                        >
                                    </v-tooltip>
                                </template>

                                <template v-slot:item.symbol="{ item }">
                                    <v-tooltip right open-delay="500">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <a
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.stop="
                                                    () => {
                                                        getEODSymbolMaps(
                                                            item.symbol
                                                        );
                                                    }
                                                "
                                                style="
                                                    background: transparent;
                                                    padding: 0px;
                                                    color: white;
                                                "
                                            >
                                                {{ item.symbol }}</a
                                            >
                                        </template>
                                        <TooltipTable :monitor-item="item" />
                                    </v-tooltip>
                                </template>
                                <template v-slot:item.net="{ item }">
                                    {{ item.netStr }}
                                </template>
                                <template v-slot:item.dailyNet="{ item }">
                                    <div v-bind:class="`${item.color}`">
                                        {{ item.dailyNetStr }}
                                    </div>
                                </template>
                                <template v-slot:item.longPositions="{ item }">
                                    {{ item.longPositionsStr }}
                                </template>
                                <template v-slot:item.shortPositions="{ item }">
                                    {{ item.shortPositionsStr }}
                                </template>
                                <template
                                    v-slot:item.floatingProfitEOD="{ item }"
                                >
                                    {{ item.floatingProfitEODStr }}
                                </template>
                                <template
                                    v-slot:item.closedProfitEOD="{ item }"
                                >
                                    <div v-bind:class="`${item.realizedColor}`">
                                        {{ item.closedProfitEODStr }}
                                    </div>
                                </template>
                                <template v-slot:item.closedProfit="{ item }">
                                    {{ item.closedProfitStr }}
                                </template>
                                <template v-slot:item.floatingProfit="{ item }">
                                    {{ item.floatingProfitStr }}
                                </template>
                                <template v-slot:item.symbolExposure="{ item }">
                                    {{ item.symbolExposureStr }}
                                </template>
                                <template
                                    v-slot:item.weightedAvgLongPrice="{ item }"
                                >
                                    {{ item.weightedAvgLongPriceStr }}
                                </template>
                                <template
                                    v-slot:item.weightedAvgShortPrice="{ item }"
                                >
                                    {{ item.weightedAvgShortPriceStr }}
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col lg="4" md="4" xs="12" cols="12" class="d-flex">
                        <div class="d-flex flex-column flex-grow-1">
                            <v-container>
                                <v-row
                                    class="d-flex align-center justify-space-between mb-4"
                                >
                                    <h3 class="ml-2">Profile Management</h3>
                                    <v-btn
                                        color="primary"
                                        @click="saveProfileDialog"
                                        icon
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-row>

                                <v-data-table
                                    :items="allProfile"
                                    hide-default-footer
                                    item-value="id"
                                    class="elevation-1"
                                    disable-pagination
                                    :height="400"
                                    :loading="loading"
                                >
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                            <tr
                                                v-for="profile in items"
                                                :class="{
                                                    'selected-row':
                                                        profile.id ===
                                                            selectedProfile.id &&
                                                        !!selectedProfile?.id,
                                                }"
                                            >
                                                <td
                                                    class="text-truncate"
                                                    @click="
                                                        UPDATE_SELECTED_PROFILE(
                                                            profile
                                                        )
                                                    "
                                                >
                                                    <span>{{
                                                        profile.text
                                                    }}</span>
                                                </td>
                                                <td
                                                    class="text-right pr-4"
                                                    style="width: 80px"
                                                >
                                                    <v-btn
                                                        icon
                                                        x-small
                                                        @click="
                                                            updateProfileDialog(
                                                                profile
                                                            )
                                                        "
                                                    >
                                                        <v-icon color="orange"
                                                            >mdi-pencil</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        icon
                                                        x-small
                                                        @click="
                                                            deleteConfirmingProfile =
                                                                profile;
                                                            confirmPopover = true;
                                                        "
                                                    >
                                                        <v-icon color="red"
                                                            >mdi-close</v-icon
                                                        >
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                            </v-container>
                            <ExposureChart
                                ref="exposureChart"
                                style="margin-top: 10px"
                                :chartHeight="exposureChartHeight"
                            />
                        </div>
                    </v-col>
                </v-row>

                <v-dialog
                    v-model="dialogCloseSummaryVisible"
                    :width="dialogWidth"
                    :hide-overlay="true"
                    :persistent="true"
                >
                    <v-card>
                        <v-app-bar
                            flat
                            color="rgba(0, 0, 0, 0)"
                            style="background: rgb(26, 57, 88)"
                        >
                            <v-toolbar-title class="text-h6 white--text pl-0"
                                >Close Summary - {{ closeSummarySymbol }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="white"
                                icon
                                @click="dialogCloseSummaryVisible = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-app-bar>

                        <v-container>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-0">
                                    <v-tabs>
                                        <v-tab
                                            dense
                                            v-on:click="changeTab('login')"
                                            >PNL by Login</v-tab
                                        >
                                        <v-tab
                                            dense
                                            v-on:click="changeTab('symbol')"
                                            >PNL by Symbol</v-tab
                                        >
                                    </v-tabs>
                                </v-col>
                            </v-row>
                            <v-row v-if="selectedKey === 'login'" class="mt-5">
                                <v-col cols="12" class="pt-0 pb-0">
                                    <v-data-table
                                        :headers="closeSummaryLoginHeaders"
                                        :items="closeSummaryLoginData"
                                        dense
                                        :header-props="{ sortIcon: null }"
                                        :search="searchCloseSummaryLogin"
                                        :items-per-page="15"
                                        :loading="tableLoading"
                                    >
                                        <template
                                            v-slot:header.login="{ header }"
                                        >
                                            {{ header.text }}
                                            <v-menu
                                                offset-y
                                                :close-on-content-click="false"
                                                top
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-icon
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click.prevent="
                                                            onSearch(
                                                                'loginSearch'
                                                            )
                                                        "
                                                    >
                                                        mdi-magnify
                                                    </v-icon>
                                                </template>
                                                <div
                                                    style="
                                                        background-color: #1e1e1e;
                                                        width: 280px;
                                                    "
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            searchCloseSummaryLogin
                                                        "
                                                        class="px-4"
                                                        type="text"
                                                        ref="loginSearch"
                                                        label="Enter the search term"
                                                        style="width: 100%"
                                                        single-line
                                                        hide-details
                                                    ></v-text-field>
                                                    <v-btn
                                                        @click="
                                                            searchCloseSummaryLogin =
                                                                ''
                                                        "
                                                        small
                                                        text
                                                        color="primary"
                                                        class="ml-2 mb-2"
                                                        style="padding: 6px"
                                                    >
                                                        Clear
                                                    </v-btn>
                                                </div>
                                            </v-menu>
                                        </template>
                                        <template v-slot:item.profit="{ item }">
                                            {{
                                                numberWithCommas(
                                                    item.profit.toFixed(2)
                                                )
                                            }}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                            <v-row v-if="selectedKey === 'symbol'" class="mt-5">
                                <v-col cols="12" class="pt-0 pb-0">
                                    <v-data-table
                                        :headers="closeSummarySymbolHeaders"
                                        :items="closeSummarySymbolData"
                                        dense
                                        :header-props="{ sortIcon: null }"
                                        :items-per-page="10"
                                        :loading="tableLoading"
                                    >
                                        <template v-slot:item.profit="{ item }">
                                            {{
                                                numberWithCommas(
                                                    item.profit.toFixed(2)
                                                )
                                            }}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>

                <LoginSummaryDialog
                    v-if="loginSummaryHistoryVisible"
                    :fullLogin="fullLoginValue"
                    :login="loginValue"
                    :server="serverValue"
                    :symbol="symbolValue"
                />
            </v-container>
        </v-card>
        <v-dialog v-model="csvFieldsDialog" width="1000" :persistent="true">
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        CSV Table Fields
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn color="white" icon @click="cancelDownload">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col cols="6" style="display: flex">
                            <v-text-field
                                v-model="inputCsvName"
                                label="CSV export name"
                                :rules="inputRules"
                                hide-details
                                required
                            ></v-text-field>

                            <b
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                                >.csv</b
                            >
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="selectAll"
                                label="Select All"
                                hide-details
                                @click="toggleSwitch"
                            >
                            </v-switch>
                        </v-col>
                        <v-col
                            cols="3"
                            v-for="item in Object.keys(selectedCSVFields)"
                        >
                            <v-checkbox
                                v-model="selectedCSVFields[item]"
                                :label="item"
                                hide-details
                                @click="checkAll"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-actions>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click="cancelDownload">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" text @click="confirmDownload">
                        Download
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="symbolMap"
            :width="800"
            :hide-overlay="true"
            :persistent="true"
            :fullscreen="fullscreen"
        >
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >EOD Symbol Price Map - {{ selectedSymbolMap }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="symbolMap = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-container>
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-data-table
                                :headers="symbolMapHeader"
                                :items="
                                    !!selectedSymbolMap
                                        ? computedSymbolPriceMapData[
                                              selectedSymbolMap
                                          ]
                                        : []
                                "
                                dense
                                :header-props="{ sortIcon: null }"
                                :items-per-page="15"
                                :mobile-breakpoint="0"
                                :footer-props="{
                                    'items-per-page-text': '',
                                }"
                                :class="{
                                    'fix-first-col': VUETIFY_BREAKPOINT.mobile,
                                }"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <SymbolDetailDialog
            :visible.sync="monitorDialog"
            :symbolLogin="currentExpanded"
            :symbolLoginDetailArray="symbolDetailArray"
            :table-loading="monitorDialogLoading"
            :showHomeLoginDetailSummary="showHomeLoginDetailSummary"
            @login-click="loadLoginSummaryHistoryDialog"
            mode="Symbol"
        />
        <a id="downloadAnchorElement" style="display: none"></a>
        <DeleteConfirmDialog
            :confirmPopover="confirmPopover"
            type="Profile"
            :name="deleteConfirmingProfile.text"
            :loading="loading"
            @close="
                () => {
                    confirmPopover = false;
                }
            "
            @confirm="deleteProfile"
        ></DeleteConfirmDialog>
    </div>
</template>
<script>
import dayjs from "dayjs";
import md5 from "md5";
import { helper } from "@components/mixins/helper";
import { permission } from "@components/mixins/permission";
import { mapActions, mapMutations, mapState } from "vuex";
import CardHead from "@views/home/ComponentCardHead";
import ExposureChart from "@views/login-monitor/ComponentLoginExposureChart";
import common from "@assets/js/common";
import LoginSummaryDialog from "@components/login-summary/ComponentLoginSummaryDialog";
import { position } from "@components/mixins/position";
import { snackbar } from "@components/mixins/snackbar";
import deepClone from "deep-clone";
import * as Sortable from "sortablejs/Sortable.min";
import DeleteConfirmDialog from "@components/ComponentDeleteConfirmDialog";
import TooltipTable from "@views/home/ComponentTooltipTable";
import SymbolDetailDialog from "@views/home/ComponentSymbolDetailDialog";
import { getOptions } from "@services/alert/config-options";
import { getAllIncludedLogins } from "@services/functional-api";
import { getWsToken } from "@services/account/auth";

function watchClass(targetNode, classToWatch) {
    let lastClassState = targetNode.classList.contains(classToWatch);
    const observer = new MutationObserver((mutationsList) => {
        for (let i = 0; i < mutationsList.length; i++) {
            const mutation = mutationsList[i];
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                const currentClassState =
                    mutation.target.classList.contains(classToWatch);
                if (lastClassState !== currentClassState) {
                    lastClassState = currentClassState;
                    if (!currentClassState) {
                        mutation.target.classList.add("sortHandle");
                    }
                }
            }
        }
    });
    observer.observe(targetNode, { attributes: true });
}

export default {
    components: {
        ExposureChart,
        LoginSummaryDialog,
        CardHead,
        DeleteConfirmDialog,
        TooltipTable,
        SymbolDetailDialog,
    },
    mixins: [helper, position, permission, snackbar],
    data() {
        return {
            profileDialog: {
                isOpen: false,
                mode: "",
                title: "",
                id: null,
            },
            allLoginList: [],
            groupOption: [],
            profileFilter: [],
            modeOptions: ["plain", "regex"],
            inputRules: [
                (v) =>
                    !!v ||
                    "Please enter a new value as the name of CSV output.",
            ],
            csvFieldsDialog: false,
            selectedCSVFields: {},
            computedCSVFields: {},
            inputCsvName: "",
            selectAll: true,
            loginSummaryHistoryVisible: false,
            pkSocket: null,
            lockReconnect: false, // 避免 socket 重复连接
            confirmPopover: false,
            sortBy: "symbolExposure",
            sortDesc: true,

            expanded: [],
            pkData: [],
            search: "",
            searchLogin: "",
            currentExpanded: "",
            symbolDetailArray: [],
            dialogCloseSummaryVisible: false,
            closeSummaryLoginData: [],
            closeSummaryLoginHeaders: [
                {
                    text: "Login",
                    align: "start",
                    sortable: false,
                    value: "login",
                },
                {
                    text: "Realized(EOD)",
                    value: "realized_eod",
                    align: "end",
                    sortable: true,
                },
                {
                    text: "Realized(MT)",
                    value: "realized_mt4",
                    align: "end",
                    sortable: true,
                },
            ],
            searchCloseSummaryLogin: "",
            closeSummarySymbolData: [],
            closeSummarySymbolHeaders: [
                {
                    text: "Symbol",
                    align: "start",
                    sortable: false,
                    value: "symbol",
                },
                {
                    text: "Realized(EOD)",
                    value: "realized_eod",
                    align: "end",
                    sortable: true,
                },
                {
                    text: "Realized(MT)",
                    value: "realized_mt4",
                    align: "end",
                    sortable: true,
                },
            ],
            searchCloseSummarySymbol: "",
            closeSummaryRawData: [],
            searchCloseSummaryRaw: "",
            selectedKey: "login",
            dialogWidth: "450px",
            closeSummarySymbol: "",
            fullLoginValue: "",
            loginValue: "",
            serverValue: "",
            symbolValue: "",
            isDataStreaming: null,
            tableHeight: 616,
            exposureChartHeight: 400,
            anIncreasingNumberForMain: 1,
            anIncreasingNumberForSub: 1,
            mainHeader: null,
            subHeader: null,
            allowSymbolDetailsDownload: false,
            isCsvRecording: false,
            symbolDetails: null,
            selectedDetailInterval: 30000,
            symbolMap: false,
            selectedSymbolMap: null,
            symbolMapHeader: [
                {
                    text: "Symbol",
                    align: "start",
                    sortable: false,
                    value: "symbolName",
                },
                {
                    text: "Ask",
                    value: "ask",
                    align: "end",
                    sortable: true,
                },
                {
                    text: "Bid",
                    value: "bid",
                    align: "end",
                    sortable: true,
                },
                {
                    text: "Date",
                    value: "dateTime",
                    align: "end",
                    sortable: true,
                },
            ],
            fullscreen: false,
            selectedLogins: null,
            profileNameInput: "",
            recordedProfitSymbolDetailMap: null,
            monitorDialog: false,
            monitorDialogLoading: false,
            currentPage: 1,
            itemsPerPage: 9,
            deleteConfirmingProfile: {},
            showHomeLoginDetailSummary: false,
            regexRule: [
                (v) => {
                    if (!v) return true;
                    try {
                        new RegExp(v);
                        return true;
                    } catch (e) {
                        return "Invalid regex syntax";
                    }
                },
            ],
            loginRule: [
                (v) => {
                    if (!v) return true;

                    const re = /^\s*\d+(?:\s*,\s*\d+)*\s*$/;

                    return (
                        re.test(v) ||
                        "Logins must be digits separated by commas (no trailing comma)"
                    );
                },
            ],
        };
    },
    computed: {
        ...mapState("LoginMonitor", [
            "socketUrl",
            "detailSocketUrl",
            "mainBookTitle",
            "exposureData",
            "loading",
            "tableLoading",
            "PNLSummaryData",
            "selectedProfile",
            "updated",
            "dialogLoading",
            "allProfile",
            "addedStatus",
        ]),
        ...mapState("SettingsServer", ["serverData"]),
        ...mapState("Home", [
            "csvFields",
            "subTableHeader",
            "mainBookTitleDesc",
            "pkHeaders",
            "lotDigits",
        ]),
        downloadExcelName() {
            return `${this.inputCsvName.replaceAll(" ", "_")}.csv`;
        },
        computedPKData() {
            const computed = this.pkData.filter((item) =>
                item.symbol.toUpperCase().includes(this.search.toUpperCase())
            );
            return computed;
        },
        computedSymbolPriceMapData() {
            const symbolMap = {};
            this.pkData.map((item) => {
                symbolMap[item.symbol] = item._eodPriceList.map((price) => {
                    price.ask = parseFloat(price.ask).toFixed(item.digits);
                    price.bid = parseFloat(price.bid).toFixed(item.digits);
                    return price;
                });
            });
            return symbolMap;
        },
    },
    watch: {
        updated(nv) {
            if (nv) {
                this.profileDialog.isOpen = false;
                this.getProfileAction({ meta_value: "login" });
                this.CHANGE_UPDATE_STATUS(false);
                this.confirmPopover = false;
            }
        },
        PNLSummaryData(nv) {
            if (nv.length == 0) {
                this.closeSummaryLoginData = [];
                this.closeSummaryRawData = [];
                this.closeSummarySymbolData = [];
            } else {
                if (this.selectedKey == "login") {
                    this.closeSummaryLoginData = nv;
                } else if (this.selectedKey == "symbol") {
                    this.closeSummarySymbolData = nv;
                } else if (this.selectedKey == "raw") {
                    this.closeSummaryRawData = nv;
                } else {
                    return;
                }
            }
        },
        // 监听close summary对话框是否打开，关闭时清空图表数据
        dialogCloseSummaryVisible(nv, ov) {
            if (!nv) {
                self = this;
                self.closeSummaryLoginData = [];
                self.closeSummarySymbolData = [];
                self.closeSummaryRawData = [];
                self.searchCloseSummaryLogin = "";
                self.searchCloseSummarySymbol = "";
                self.searchCloseSummaryRaw = "";
            }
        },
        selectedProfile(nv) {
            this.UPDATE_BTN_STATUS(true);
            this.UPDATE_LOADING(true);
            if (nv !== null) {
                // reset all table related data
                this.searchLogin = "";
                this.isDataStreaming = false;
                this.UPDATE_EXPOSURE_DATA({});
                this.pkData = [];
                this.UPDATE_MAIN_BOOK_TITLE({
                    unrealized: 0,
                    realized: 0,
                    dailyNet: 0,
                });
                this.expanded = [];

                if (this.pkSocket) {
                    this.pkSocket.close();
                }

                const profileFilter = deepClone(
                    nv?.["params"]?.["profile_filter"]
                );
                profileFilter.forEach((item) => {
                    if (typeof item.group === "string" && item.group === "*") {
                        item.group = ".*";
                    }
                });

                getAllIncludedLogins({
                    profile_filter: profileFilter,
                })
                    .then((res) => {
                        this.allLoginList = res.data.map(
                            (item) => item.server_login
                        );
                    })
                    .catch((e) => {
                        this.snackBarDanger(
                            "Please double check the profile filter settings before trying again."
                        );
                    })
                    .finally(() => {
                        this.UPDATE_LOADING(false);
                    });
            }
        },
        isDataStreaming(nv) {
            if (nv === true) {
                this.UPDATE_BTN_STATUS(false);
                this.snackBarSuccess("Connection Established");
            }
        },
        allLoginList(nv) {
            if (nv.length) {
                this.snackBarInfo("Connecting to socket...", 5000);
                this.createPKWebSocket();
            }
        },
    },
    methods: {
        ...mapActions("LoginMonitor", [
            "getProfileAction",
            "getPNLSummaryAction",
            "postProfileAction",
            "putProfileAction",
            "deleteProfileAction",
        ]),
        ...mapMutations("LoginMonitor", [
            "UPDATE_MAIN_BOOK_TITLE",
            "UPDATE_EXPOSURE_DATA",
            "UPDATE_BTN_STATUS",
            "UPDATE_SELECTED_PROFILE",
            "CHANGE_UPDATE_STATUS",
            "UPDATE_LOADING",
            "UPDATE_ADDED_STATUS",
        ]),
        isValidRegex(pattern) {
            if (!pattern) return true;
            try {
                new RegExp(pattern);
                return true;
            } catch (_) {
                return false;
            }
        },
        isValidLoginCsv(v) {
            if (!v) return true;
            return /^\s*\d+(?:\s*,\s*\d+)*\s*$/.test(v);
        },
        passedValidation() {
            if (!this.profileNameInput) {
                this.snackBarDanger("Profile Name is required.");
                return false;
            }

            for (const filter of this.profileFilter) {
                if (!filter.server_id) {
                    this.snackBarDanger(
                        "Server filter is required for all profile filters."
                    );
                    return false;
                }

                const hasGroup =
                    (typeof filter.group === "string" &&
                        filter.group.trim() !== "") ||
                    (Array.isArray(filter.group) && filter.group.length > 0);

                const hasLogin = !!(
                    filter.login && String(filter.login).trim()
                );

                if (!hasGroup && !hasLogin) {
                    this.snackBarDanger(
                        "At least one group or login filter is required for all profile filters."
                    );
                    return false;
                }

                if (hasLogin && !this.isValidLoginCsv(filter.login)) {
                    this.snackBarDanger(
                        "Login must be digits separated by commas (whitespace allowed, no trailing comma)."
                    );
                    return false;
                }

                if (filter.group_mode === "regex") {
                    const pattern =
                        typeof filter.group === "string"
                            ? filter.group.trim()
                            : "";
                    if (pattern && !this.isValidRegex(pattern)) {
                        this.snackBarDanger("Group regex is invalid.");
                        return false;
                    }
                }
            }

            return true;
        },

        onModeChange(data) {
            if (typeof data["group"] === "object") {
                data["group"] = "";
            } else {
                data["group"] = [];
            }
        },
        addNewProfileFilter() {
            this.profileFilter.push({
                server_id: null,
                group_mode: "plain",
                group: [],
                login: "",
            });
        },
        removeProfileFilter(index) {
            this.profileFilter.splice(index, 1);
        },
        getSubTableLogin(login) {
            return login.split(":")[1] + ":" + login.split(":")[2];
        },
        toggleSwitch() {
            if (!this.selectAll) {
                const copy = deepClone(this.selectedCSVFields);
                Object.keys(this.csvFields).map((item) => (copy[item] = false));
                this.selectedCSVFields = copy;
            } else {
                const copy = deepClone(this.selectedCSVFields);
                Object.keys(this.csvFields).map((item) => (copy[item] = true));
                this.selectedCSVFields = copy;
            }
        },
        checkAll() {
            let allSelected = true;
            Object.keys(this.selectedCSVFields).map((item) => {
                allSelected = allSelected && this.selectedCSVFields[item];
            });
            this.selectAll = allSelected;
        },
        startDownload() {
            this.selectAll = true;
            this.selectedCSVFields = {};
            this.isCsvRecording = true;
            Object.keys(this.csvFields).map(
                (item) => (this.selectedCSVFields[item] = true)
            );
            this.inputCsvName =
                "position login profile - " + this.selectedProfile.text;
            this.csvFieldsDialog = true;
        },
        confirmDownload() {
            let copy = deepClone(this.csvFields);
            Object.keys(this.selectedCSVFields).map((item) => {
                if (!this.selectedCSVFields[item]) {
                    delete copy[item];
                }
            });
            this.computedCSVFields = copy;
            if (Object.keys(this.computedCSVFields).length === 0) {
                this.snackBarDanger("Please selected at least one field");
            } else {
                document.getElementById("csvExport").click();
                if (this.allowSymbolDetailsDownload && this.monitorDialog) {
                    var dataStr =
                        "data:text/json;charset=utf-8," +
                        encodeURIComponent(JSON.stringify(this.symbolDetails));
                    var dlAnchorElem = document.getElementById(
                        "downloadAnchorElement"
                    );
                    dlAnchorElem.setAttribute("href", dataStr);
                    dlAnchorElem.setAttribute("download", "SymbolDetails.json");
                    dlAnchorElem.click();
                }
            }
        },
        cancelDownload() {
            this.csvFieldsDialog = false;
        },
        async fetchData() {
            this.csvFieldsDialog = false;
            return this.computedPKData;
        },
        sortPKHeadersAndUpdateTheKey(evt) {
            const headersTmp = this.mainHeader;
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (newIndex >= headersTmp.length) {
                let k = newIndex - headersTmp.length + 1;
                while (k--) {
                    headersTmp.push(undefined);
                }
            }
            headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
            localStorage.setItem(
                "loginMonitorMainHeader",
                JSON.stringify(headersTmp)
            );
            this.anIncreasingNumberForMain += 1;
        },
        sortSubHeadersAndUpdateTheKey(evt) {
            const headersTmp = this.subHeader;
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (newIndex >= headersTmp.length) {
                let k = newIndex - headersTmp.length + 1;
                while (k--) {
                    headersTmp.push(undefined);
                }
            }
            headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
            localStorage.setItem(
                "loginMonitorSubHeader",
                JSON.stringify(headersTmp)
            );
            this.anIncreasingNumberForSub += 1;
        },
        createPKWebSocket() {
            try {
                if ("WebSocket" in window) {
                    this.pkSocket = new WebSocket(this.socketUrl);
                }
                this.initWSEventHandle();
            } catch (e) {
                this.reconnect();
            }
        },
        initWSEventHandle() {
            // on socket message coming
            this.pkSocket.onopen = (evt) => {
                this.onWebSocketOpen(evt);
            };

            this.pkSocket.onmessage = (evt) => {
                this.onWebSocketMessage(evt);
            };

            this.pkSocket.onclose = (evt) => {
                this.reconnect();
                console.log("on close: ", evt);
            };

            this.pkSocket.onerror = (evt) => {
                this.reconnect();
                console.log("On error: ", evt);
            };
        },
        reconnect() {
            if (this.lockReconnect) return;
            this.lockReconnect = true;
            setTimeout(() => {
                if (this.pkSocket == null || this.pkSocket.readyState == 3) {
                    if (this.selectedLogins?.length > 0) {
                        console.log("reconnecting...");
                        const lastSelection = this.selectedProfile;
                        this.UPDATE_SELECTED_PROFILE(null);
                        this.UPDATE_SELECTED_PROFILE(lastSelection);
                    }
                }
                this.lockReconnect = false;
            }, 1000);
        },
        setHeights() {
            const innerHeight = window.innerHeight;
            this.tableHeight =
                innerHeight - 273 > 636 ? innerHeight - 273 : 636;

            this.exposureChartHeight = innerHeight * 0.4;
            // this.exposureChartHeight =
            //         innerHeight - 130 - this.allBookTableHeight - 37 - 39 > 200
            //             ? innerHeight - 130 - this.allBookTableHeight - 37 - 39
            //             : 200;
        },
        onResize() {
            this.setHeights();
        },
        rowClicked(data) {
            if (this.monitorDialog === false) {
                if (this.currentExpanded === data.symbol) {
                    this.monitorDialog = true;
                } else {
                    this.currentExpanded = data.symbol;
                    this.symbolDetailArray = [];
                    this.$nextTick(() => {
                        this.sendExpandSymbolRequest();
                    });
                }
            } else {
                if (this.currentExpanded !== data.symbol) {
                    this.currentExpanded = data.symbol;
                    this.symbolDetailArray = [];
                    this.$nextTick(() => {
                        this.sendExpandSymbolRequest();
                    });
                }
            }
        },
        sendExpandSymbolRequest() {
            this.monitorDialog = true;
            this.monitorDialogLoading = true;
            const pullCommand = {
                externalMsgType: "CMD_PULL_IB_SYMBOL_RESULT",
                ref: "|" + this.currentExpanded,
            };
            this.pkSocket.send(JSON.stringify(pullCommand));
        },
        filterTable(value, search, item) {
            return (
                value !== null &&
                search !== null &&
                typeof value === "string" &&
                value.toString().toLowerCase().indexOf(search.toLowerCase()) !==
                    -1
            );
        },
        customSort(items, sortBy, sortDesc) {
            items.sort((a, b) => {
                if (sortBy[0] === "net") {
                    if (!sortDesc[0])
                        return (
                            Math.abs(a.longPositions + a.shortPositions) -
                            Math.abs(b.longPositions + b.shortPositions)
                        );
                    if (sortDesc[0])
                        return (
                            Math.abs(b.longPositions + b.shortPositions) -
                            Math.abs(a.longPositions + a.shortPositions)
                        );
                } else if (sortBy[0] === "dailyNet") {
                    if (!sortDesc[0])
                        return (
                            a.floatingProfitEOD +
                            a.closedProfitEOD -
                            (b.floatingProfitEOD + b.closedProfitEOD)
                        );
                    if (sortDesc[0])
                        return (
                            b.floatingProfitEOD +
                            b.closedProfitEOD -
                            (a.floatingProfitEOD + a.closedProfitEOD)
                        );
                } else if (sortBy[0] === "symbol") {
                    if (!sortDesc[0]) return a.symbol.localeCompare(b.symbol);
                    if (sortDesc[0]) return b.symbol.localeCompare(a.symbol);
                } else {
                    if (!sortDesc[0]) {
                        return a[sortBy] < b[sortBy] ? -1 : 1;
                    } else {
                        return b[sortBy] < a[sortBy] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        changeTab(key) {
            this.selectedKey = key;
            if (key !== "raw") {
                this.dialogWidth = "500px";
            } else {
                this.dialogWidth = "1200px";
            }

            const params = {
                symbol: this.closeSummarySymbol,
                date: common.getMT4TimeString().split(" ")[0] + " 00:00:00",
                key: this.selectedKey,
            };
            this.getPNLSummaryAction(params);
        },
        async onWebSocketOpen() {
            try {
                const res = await getWsToken();
                const data = {
                    token: res.data.ws_token,
                    externalMsgType: "CMD_AUTHORIZATION",
                };
                this.pkSocket.send(JSON.stringify(data));
            } catch (error) {
                console.error("Failed to get WebSocket token:", error);
            }
        },
        onWebSocketMessage(evt) {
            let msg = evt.data;
            msg = msg.replace("$_", "");
            const ORIGIN_HASH_MSG = md5(msg);

            // decode data
            let decodedMsg = this.unzipVersion(msg);
            // console.log(decodedMsg);
            // if data is in string format, parse it
            if (typeof decodedMsg === "string")
                decodedMsg = JSON.parse(decodedMsg);
            if (decodedMsg === null) return;

            // console.log(decodedMsg);

            if (
                decodedMsg.code === "INVALID_PERMISSION" ||
                decodedMsg.code === "AUTH_FAILED"
            ) {
                getWsToken().then((res) => {
                    const data = {
                        token: res.data.ws_token,
                        externalMsgType: "CMD_AUTHORIZATION",
                    };
                    this.pkSocket.send(JSON.stringify(data));
                }).catch((error) => {
                    console.error("Failed to get WebSocket token:", error);
                });
            }
            if (
                decodedMsg.externalMsgType === "RESPONSE_AUTH" &&
                decodedMsg.code === "OK"
            ) {
                const request = {
                    ib_id: [],
                    customer_id: [],
                    back_office_id: [],
                    login: [],
                    server_login: this.allLoginList,
                    externalMsgType: "CMD_SUBSCRIBE_IB_USERS",
                };

                this.pkSocket.send(JSON.stringify(request));
            }
            if (decodedMsg.externalMsgType === "DATA_PROFIT_IB_RESULT") {
                this.isDataStreaming = true;
            }
            // symbol detail
            if (decodedMsg.externalMsgType === "DATA_SYMBOL_PROFIT_IB_RESULT") {
                const matchingRef =
                    "|" + this.currentExpanded === decodedMsg?.ref;

                console.log(decodedMsg);

                // console.log(this.currentExpanded, matchingRef);
                // if(true){
                if (this.currentExpanded !== "" && matchingRef) {
                    // hash code is diff then update detail data
                    if (ORIGIN_HASH_MSG !== this.symbolDetailOriginHash) {
                        if (this.isCsvRecording) {
                            this.symbolDetails =
                                decodedMsg.userProfitDetailsBySymbolHashMap;
                            this.isCsvRecording = false;
                        }
                        // console.log(decodedMsg)
                        const expandMap =
                            decodedMsg.userProfitDetailsBySymbolHashMap;
                        const digits = decodedMsg.digits;

                        const expandData = [];
                        for (const item in expandMap) {
                            // console.log(expandMap[item])
                            const {
                                longPositions,
                                shortPositions,
                                netPositions,
                                floatingProfitEOD,
                                closedProfitEOD,
                                floatingProfit,
                                login,
                                closedProfit,
                                weightedAvgLongPrice,
                                weightedAvgShortPrice,
                                exposure,
                            } = expandMap[item];
                            expandData.push({
                                fullLogin: login,
                                login:
                                    login.split(":")[1] +
                                    ":" +
                                    login.split(":")[2],
                                longPositions: this.numberWithCommas(
                                    longPositions.toFixed(this.lotDigits)
                                ),
                                shortPositions: this.numberWithCommas(
                                    shortPositions.toFixed(this.lotDigits)
                                ),
                                netPositions: this.numberWithCommas(
                                    netPositions.toFixed(this.lotDigits)
                                ),
                                dailyNet: this.numberWithCommas(
                                    (
                                        floatingProfitEOD + closedProfitEOD
                                    ).toFixed(2)
                                ),
                                floatingProfitEOD: this.numberWithCommas(
                                    floatingProfitEOD.toFixed(2)
                                ),
                                floatingProfit: this.numberWithCommas(
                                    floatingProfit.toFixed(2)
                                ),
                                closedProfitEOD: this.numberWithCommas(
                                    closedProfitEOD.toFixed(2)
                                ),
                                closedProfit: this.numberWithCommas(
                                    closedProfit.toFixed(2)
                                ),
                                // problems here
                                weightedAvgLongPrice:
                                    weightedAvgLongPrice.toFixed(digits),
                                weightedAvgShortPrice:
                                    weightedAvgShortPrice.toFixed(digits),
                                exposure: this.numberWithCommas(
                                    exposure.toFixed(2)
                                ),
                            });
                        }
                        this.symbolDetailArray = expandData;
                        this.monitorDialogLoading = false;
                        this.symbolDetailOriginHash = ORIGIN_HASH_MSG;
                    }

                    // repull expanded data
                    const pullCommand = {
                        externalMsgType: "CMD_PULL_IB_SYMBOL_RESULT",
                        ref: "|" + this.currentExpanded,
                    };
                    if (!!this.monitorDialog) {
                        setTimeout(() => {
                            this.pkSocket.send(JSON.stringify(pullCommand));
                        }, 1000);
                    } else {
                        this.currentExpanded = undefined;
                        this.symbolDetailOriginHash = undefined;
                    }
                }
            }
            // if return data is about streaming, handle data to make the table updated
            if (decodedMsg.externalMsgType === "DATA_PROFIT_IB_RESULT") {
                // console.log(decodedMsg);

                const td = decodedMsg.profitSymbolDetailMap;
                this.recordedProfitSymbolDetailMap =
                    decodedMsg.profitSymbolDetailMap;

                for (const item in td) {
                    const dataItem = td[item];
                    const _ITEM_HASH = md5(JSON.stringify(dataItem));
                    dataItem._ITEM_HASH = _ITEM_HASH;
                    const {
                        longPositions,
                        shortPositions,
                        floatingProfitEOD,
                        closedProfitEOD,
                        eodPriceMap,
                        floatingProfit,
                        closedProfit,
                        symbolExposure,
                        weightedAvgLongPrice,
                        weightedAvgShortPrice,
                        digits,
                    } = dataItem;
                    dataItem.symbol = item;

                    // process eodPriceMap
                    dataItem._eodPriceList = [];
                    for (const symbolName in eodPriceMap) {
                        const [ask, bid, dateTime] =
                            eodPriceMap[symbolName].split(",");
                        dataItem._eodPriceList.push({
                            symbolName,
                            ask,
                            bid,
                            dateTime: this.toMTTimeString(dateTime),
                        });
                    }
                    dataItem.net = this.roundDecimal(
                        longPositions - shortPositions,
                        2
                    );

                    dataItem.netStr = this.numberWithCommas(
                        this.roundDecimal(
                            longPositions - shortPositions,
                            this.lotDigits
                        )
                    );
                    dataItem.dailyNet = this.roundDecimal(
                        floatingProfitEOD + closedProfitEOD,
                        2
                    );
                    dataItem.dailyNetStr = this.numberWithCommas(
                        this.roundDecimal(
                            floatingProfitEOD + closedProfitEOD,
                            2
                        )
                    );
                    dataItem.symbolExposureStr = this.numberWithCommas(
                        symbolExposure.toFixed(2)
                    );
                    dataItem.floatingProfitStr = this.numberWithCommas(
                        floatingProfit.toFixed(2)
                    );
                    dataItem.longPositionsStr = this.numberWithCommas(
                        longPositions.toFixed(this.lotDigits)
                    );
                    dataItem.shortPositionsStr = this.numberWithCommas(
                        shortPositions.toFixed(this.lotDigits)
                    );
                    dataItem.floatingProfitEODStr = this.numberWithCommas(
                        floatingProfitEOD.toFixed(2)
                    );
                    dataItem.closedProfitEODStr = this.numberWithCommas(
                        closedProfitEOD.toFixed(2)
                    );
                    dataItem.closedProfitStr = this.numberWithCommas(
                        closedProfit.toFixed(2)
                    );
                    dataItem.weightedAvgLongPriceStr =
                        weightedAvgLongPrice.toFixed(digits);
                    dataItem.weightedAvgShortPriceStr =
                        weightedAvgShortPrice.toFixed(digits);
                    const foundIndex = this.pkData.findIndex((data) => {
                        return data.symbol === item;
                    });
                    const found = this.pkData[foundIndex];
                    if (!found) {
                        dataItem.color = "";
                        dataItem.realizedColor = "";
                        this.pkData.push(Object.freeze(dataItem));
                    } else {
                        dataItem.color =
                            Number(found?.dailyNet) > Number(dataItem?.dailyNet)
                                ? "green"
                                : Number(found?.dailyNet) ===
                                  Number(dataItem?.dailyNet)
                                ? ""
                                : "red";

                        dataItem.realizedColor =
                            Number(found?.closedProfitEOD) >
                            Number(dataItem?.closedProfitEOD)
                                ? "green"
                                : Number(found?.closedProfitEOD) ===
                                  Number(dataItem?.closedProfitEOD)
                                ? found.realizedColor
                                : "red";
                        this.pkData.splice(
                            foundIndex,
                            1,
                            Object.freeze(dataItem)
                        );
                    }
                }

                // big three title: UNREALIZED, REALIZED, DAILY NET
                this.UPDATE_MAIN_BOOK_TITLE({
                    unrealized: decodedMsg.floatingProfitsEOD,
                    realized: decodedMsg.closedProfitsEOD,
                    dailyNet:
                        decodedMsg.floatingProfitsEOD +
                        decodedMsg.closedProfitsEOD,
                });

                // update exposure data into state
                if (
                    Object.keys(this.exposureData).length == 0 ||
                    parseInt(Date.now() / 1000) % 5 == 0
                ) {
                    this.UPDATE_EXPOSURE_DATA(decodedMsg.exposureMap);
                }
            }
        },
        onWindowFocus() {
            this.reconnect();
        },
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        toMTTimeString(timestamp) {
            const utc = require("dayjs/plugin/utc");
            const timezone = require("dayjs/plugin/timezone");
            dayjs.extend(utc);
            dayjs.extend(timezone);
            const date = dayjs
                .unix(timestamp)
                .tz("UTC")
                .format("YYYY-MM-DD HH:mm:ss");
            return date;
        },
        saveProfileDialog() {
            this.profileNameInput = "";
            this.profileDialog.isOpen = true;
            this.profileDialog.title = "Add New Profile";
            this.profileDialog.mode = "Add";
            this.profileDialog.id = -1;
            this.profileFilter = [];
        },
        saveProfile() {
            const copyFilter = deepClone(this.profileFilter);
            copyFilter.forEach((item) => {
                if (typeof item.group === "string" && item.group === "*") {
                    item.group = ".*";
                }
            });
            if (this.passedValidation()) {
                const params = {
                    meta_value: "login",
                    profile_name: this.profileNameInput,
                    value: {
                        profile_filter: copyFilter,
                    },
                };
                this.postProfileAction(params);
            }
        },
        updateProfileDialog(profile) {
            this.profileNameInput = profile?.text;
            this.profileDialog.isOpen = true;
            this.profileDialog.title = "Update Profile - " + profile.text;
            this.profileDialog.mode = "update";
            this.profileDialog.id = profile.id;
            this.profileFilter = deepClone(profile.params?.profile_filter);
        },
        updateProfile() {
            const copyFilter = deepClone(this.profileFilter);
            copyFilter.forEach((item) => {
                if (typeof item.group === "string" && item.group === "*") {
                    item.group = ".*";
                }
            });
            if (this.passedValidation()) {
                const params = {
                    id: this.profileDialog.id,
                    profile_name: this.profileNameInput,
                    value: {
                        profile_filter: copyFilter,
                    },
                };
                this.putProfileAction(params);
            }
        },
        deleteProfile() {
            const params = {
                id: this.deleteConfirmingProfile.id,
            };
            this.deleteProfileAction(params);
        },
        getEODSymbolMaps(data) {
            this.symbolMap = true;
            this.selectedSymbolMap = data;
        },
        loadLoginSummaryHistoryDialog(item) {
            // split login string to get login value
            const [server, login] = item.login.split(":");
            this.fullLoginValue = item.fullLogin;
            this.loginValue = login;
            this.serverValue = server;
            this.symbolValue = this.currentExpanded;

            this.loginSummaryHistoryVisible = false;
            this.$nextTick(() => {
                this.loginSummaryHistoryVisible = true;
            });
        },
    },
    mounted() {
        this.setHeights();
    },
    created() {
        getOptions("group").then((res) => {
            this.groupOption = res.data;
        });
        const userFunction = this.getFunction("book");

        if (userFunction.includes("homeLoginDetailSummary")) {
            this.showHomeLoginDetailSummary = true;
        }
        this.UPDATE_LOADING(true);
        this.getProfileAction({ meta_value: "login" });
        window.addEventListener("focus", this.reconnect);

        document.addEventListener("visibilitychange", this.userFocus);

        var localSavedMainHeader = localStorage.getItem(
            "loginMonitorMainHeader"
        );
        var localSavedSubHeader = localStorage.getItem("loginMonitorSubHeader");

        if (!!localSavedMainHeader) {
            this.mainHeader = JSON.parse(localSavedMainHeader);
        } else {
            this.mainHeader = deepClone(this.pkHeaders);
        }

        if (!!localSavedSubHeader) {
            this.subHeader = JSON.parse(localSavedSubHeader);
        } else {
            this.subHeader = deepClone(this.subTableHeader);
        }

        if (this.pkSocket) this.pkSocket.close();
    },
    destroyed() {
        if (this.pkSocket !== null) {
            this.pkSocket.close();
        }

        window.removeEventListener("focus", this.reconnect);
    },
    directives: {
        "sortable-table": {
            inserted: (el, binding) => {
                el.querySelectorAll("th").forEach((draggableEl) => {
                    // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
                    watchClass(draggableEl, "sortHandle");
                    draggableEl.classList.add("sortHandle");
                });
                Sortable.create(
                    el.querySelector("tr"),
                    binding.value
                        ? { ...binding.value, handle: ".sortHandle" }
                        : {}
                );
            },
        },
    },
};
</script>

<style scoped>
.td-up {
    background-color: #27ae60;
}

.td-down {
    background-color: #c0392b;
}

.td-alert {
    background-color: #c0392b;
}
.hover-login-tooltip:hover {
    cursor: pointer;
}
.symbol-detail:hover {
    cursor: pointer;
}

#home-table table > tbody {
    /* height: 600px; */
    overflow-y: scroll;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__content
    > td
    > div.v-data-table.v-data-table--dense.v-data-table--fixed-header.theme--dark
    > div
    > table
    > tbody
    > tr:nth-child(n) {
    height: 32px;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__content
    > td
    > div.v-data-table.v-data-table--dense.v-data-table--fixed-header.theme--dark
    > div
    > table
    > tbody {
    height: 32px;
}
.home-checkbox .v-label {
    font-size: 12px;
}
.home-checkbox .v-messages {
    display: none;
}
#global-container
    > div.home
    > div
    > div
    > div:nth-child(5)
    > div:nth-child(2)
    > div.col-md-5.col-lg-5.col-12
    > div:nth-child(2)
    > div:nth-child(n)
    > button:hover {
    background-color: #2196f3;
}
#home-table > div.v-data-table__wrapper > table > tbody > tr:nth-child(n) {
    height: 19px;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__row:nth-child(n) {
    height: 32px;
}

#home-table table > tbody::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

#home-table table > tbody::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
}

#home-table table > tbody::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

    background-color: #555;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
}

.v-btn:not(.v-btn--round).v-size--small {
    height: 19px;
}
.v-tab {
    padding: 0 7px;
}

.tooltip-table,
.tooltip-data {
    border: 1px solid white;
    border-collapse: collapse;
}

.tooltip-data {
    padding: 0px 5px 0px 5px;
}
.profile-card {
    position: relative;
    height: 140px;
}

.square-tile {
    aspect-ratio: 1 / 1;
    width: 100%;
}

.edit-btn {
    position: absolute;
    top: 4px;
    right: 20px;
    z-index: 1;
}

.delete-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
}

.profile-name {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    text-align: center;
    transform: translateY(-50%);
    padding: 0 16px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.selected-card {
    border: 2px solid #1976d2 !important;
}

.selected-row {
    background-color: #539ed4; /* Light blue or any highlight color */
}

.show-details >>> .v-text-field__details {
    display: block !important;
}
</style>
